<template>
  <v-container fluid class="login-bg fill-height">
    <v-row class="login-blur mx-4" align="center" justify="center">
      <v-col cols="12" sm="12" md="4" xl="4" :rounded="0" class="pa-0">
        <v-card class="elevation-0 pa-8 pa-xs-2" :rounded="0">
          <v-toolbar color="#ffffff" style="height: 100px">
            <v-row class="">
              <v-col cols="12" class="pa-0" align="center"
                ><h1 class="welcome-text font-weight-bold">Janus4cast</h1>
                <p></p
              ></v-col>
            </v-row>
          </v-toolbar>
          <v-card-text class="pb-1 pa-sm-1">
            <v-form ref="form" v-model="valid" @keyup.enter="auth">
              <v-text-field
                label="Username"
                name="login"
                prepend-inner-icon="mdi-account"
                type="text"
                v-model="form.username"
                :rules="nameRules"
                required
                color="var(--text)"
                class="mr-9"
              ></v-text-field>
              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-inner-icon="mdi-lock"
                v-model="form.password"
                :rules="passRules"
                required
                solo
                filled
                color="var(--text)"
                @click:append="pass = !pass"
                :type="pass ? 'text' : 'password'"
                :append-icon="pass ? 'mdi-eye' : 'mdi-eye-off'"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="pt-1" align="center" justify="center">
            <v-row justify="center">
              <!-- <v-col
                cols="6"
                lg="6"
                md="12"
                sm="12"
                class="py-1 text-right pr-0 button-group-login"
              >
                <v-btn
                  :rounded="0"
                  style="background-color: var(--text-2)"
                  min-width="100%"
                  @click="auth"
                  class="rounded-l-xl elevation-6"
                >
                  <p class="text-white login-text">Register</p>
                </v-btn>
              </v-col>-->
              <v-col
                cols="12"
                sm="12"
                md="4"
                xl="6"
                class="py-1 text-center pl-0"
              >
                <v-progress-circular
                  v-show="getLoadingUser"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <v-btn
                  v-show="!getLoadingUser"
                  class="bg-primary elevation-0"
                  variant="elevated"
                  @click="auth"
                  min-width="100%"
                  :disabled="getLoadingUser"
                  >Login</v-btn
                >
              </v-col>
              <!--<v-col cols="12" class="py-1 text-center mt-2">
                <v-btn
                  class="rounded-xl elevation-6 button-login-2"
                  @click="auth"
                  min-width="100%"
                  style="background-color: var(--text-2)"
                  ><p class="login-text-2">LogIn</p></v-btn
                >
              </v-col>-->
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-snackbar
        v-model="snackbar"
        timeout="10000"
        color="red-darken-2"
        vertical
      >
        <div class="text-subtitle-1 pb-2">Error into LogIn</div>

        <p>Invalid email or password</p>

        <template v-slot:actions>
          <v-btn color="white" variant="text" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Login_",
  data: () => {
    return {
      form: {
        username: "",
        password: "",
      },
      valid: false,
      snackbar: false,
      nameRules: [(v) => !!v || "Name is required"],
      passRules: [(v) => !!v || "Password is required"],
      pass: false,
    };
  },
  computed: {
    ...mapGetters(["getLoadingUser", "getUserInvalid"]),
  },
  watch: {
    getUserInvalid(value) {
      if (value) {
        this.snackbar = value;
      }
    },
  },
  methods: {
    ...mapActions(["login"]),

    auth() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.login(this.form);
        }
      });
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: var(--f-body);
}
.welcome-text {
  color: var(--text);
  font-family: var(--f-display);
  font-size: 30px;
  letter-spacing: -0.025em;
}
.login-blur {
  height: 100vh;
}
.login-text {
  font-family: var(--f-body);
  font-size: 14px;
}
.login-text-2 {
  font-family: var(--f-body);
  font-size: 16px;
  color: white;
}
.login-bg {
  /* flat institutional ground — no gradients or glow */
  background: var(--bg-0);
  height: 100vh;
  width: 100%;
}
@media screen and (max-width: 450px) {
  .welcome-text {
    font-size: 24px;
  }
}
</style>